import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchQuestionsChapterWise = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/question-bank/all-questions`, data);
};

module.exports = { fetchQuestionsChapterWise };



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionsViewList/ApiService.js